// extracted by mini-css-extract-plugin
export default {"title":"Profiles_title__qplfw","verticalContainer":"Profiles_verticalContainer__WKRCQ"};